/* RESPONSIBLE TEAM: team-ai-agent-2 */

import Model, { attr } from '@ember-data/model';
import { buildValidations } from 'ember-cp-validations';

interface AiAgentIdentity {
  id: string;
  name: string;
  avatar: AiAgentIdentityAvatar;
  isDefault: boolean;
}

interface AiAgentIdentityAvatar {
  avatarType: string;
  avatarData: {
    avatarShape: string;
    url: string;
  };
}

const Validations = buildValidations({});
export default class BrandAiAgentIdentity extends Model.extend(Validations) {
  @attr('string') declare brandId: string;
  @attr('string') declare brandName: string;
  @attr('boolean') declare isDefaultBrand: boolean;
  @attr() declare aiAgentIdentity: AiAgentIdentity;
}
